import React from 'react';
import { amountFormatter, labelForWalletCategoryType , walletErDetailPageMessages } from 'azshared';
import { useIntl } from 'react-intl';
import { Loader, LoaderSize } from '../../../../../components/loader/loader';
import InfographicPie from '../../../../../components/infographic-pie/infographic-pie';
import './portfolio-asset-class.scss';
import { RealEconomyAssetSummary } from 'azshared/build/main/lib/model/wallet/wallet-ow';

interface Props {
  loading: boolean;
  items: RealEconomyAssetSummary;
}

export const PortfolioAssetClass = (props: Props) => {
  const { formatMessage } = useIntl();
  const { loading, items } = props;

  return (
    <div className={`portfolio-summary ${!loading ? 'gap' : ''}`}>
      <h4 style={{color:'black',fontWeight:'bold'}}>{formatMessage(walletErDetailPageMessages.portfolioAssetClassTitle)}</h4>
      <div className={'portfolio-container' + (loading ? '-loader' : '')}>
        {loading && <Loader loadersize={LoaderSize.XL} />}
        {!loading && (
          <InfographicPie
            items={items?.category?.filter(p=>p.quote !== 0).map((m) => {
              return { value: (m.quote??0)*100, label: formatMessage(labelForWalletCategoryType(m.type)) };
            })}
            title={formatMessage(walletErDetailPageMessages.portfoglioSummaryTotal)}
            subtitle={amountFormatter(items.totalAmount)}
            legend
            biggerActiveItem
            legendAlignment={'left'}
          />
        )}
      </div>
    </div>
  );
};
